import {
  SERVICE_HOLDER_EXPRESION_CAN_HAVE_A_CONVERSATION,
  SERVICE_HOLDER_EXPRESION_HAVE_DIFFICULTIES,
  SERVICE_HOLDER_EXPRESION_UNDERSTANDABLE,
} from "./serviceHolder";

const speechLevels = [
  {
    value: SERVICE_HOLDER_EXPRESION_CAN_HAVE_A_CONVERSATION,
  },
  {
    value: SERVICE_HOLDER_EXPRESION_HAVE_DIFFICULTIES,
  },
  {
    value: SERVICE_HOLDER_EXPRESION_UNDERSTANDABLE,
  },
];

export function speechLevelsList() {
  return speechLevels;
}
